<template>
  <AuthWrapper>
    <div class="auth-contents">
      <a-form @finish="handleSubmit" :model="formState" layout="vertical">
        <sdHeading as="h3">{{ $t('pages.forgot-password.title') }}</sdHeading>
        <p class="forgot-text">
          {{ $t('pages.forgot-password.forgot-text') }}
        </p>
        <a-form-item :label="$t('pages.forgot-password.email-address')" name="email">
          <a-input type="email" v-model:value="formState.email" :placeholder="$t('pages.forgot-password.email-placeholder')" />
        </a-form-item>
        <a-form-item>
          <sdButton class="btn-reset" htmlType="submit" type="primary" size="large" :disabled="isLoading">
            {{ isLoading ? $t('common.loading') : $t('pages.forgot-password.btn-reset') }}
          </sdButton>
        </a-form-item>
        <p class="return-text">{{$t('pages.forgot-password.return-to')}} <router-link to="/auth/login">{{$t('pages.forgot-password.sign-in')}}</router-link></p>
      </a-form>
    </div>
  </AuthWrapper>
</template>
<script>
import { AuthWrapper } from './style';
import axios from 'axios';
import { notification } from 'ant-design-vue';

export default {
  name: 'ForgotPassword',
  components: { AuthWrapper },
  data() {
    return {
      formState: {
        email: '',
      },
      isLoading: false,
    };
  },
  methods: {
    handleSubmit() {
      this.isLoading = true;
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + this.$endpoints.auth_password_forgot, this.formState)
        .then(response => {
          if (response.data.status === true) {
            notification.success({
              message: this.$t('pages.forgot-password.success-text'),
            });
          } else {
            notification.error({
              message: 'Error',
            });
          }
          this.isLoading = false;
        })
        .catch(e => {
          notification.error({
            message: 'Error',
          });
          this.isLoading = false;
        });
    },
  },
};
</script>
